import {
    Pipe,
    PipeTransform,
} from '@angular/core';

export enum FileSizePipeUnits {
  bytes = 0,
  KB = 1,
  MB = 2,
  GB = 3,
  TB = 4,
  PB = 5,
}

@Pipe({
  name: 'ui-file-size',
  pure: true,
})
export class FileSizePipe implements PipeTransform {

  transform(bytes: number = 0, precision: number = 2): string {
    if (
      isNaN(parseFloat(String(bytes))) ||
      !isFinite(bytes)
    ) { return '...'; }

    let unit = 0;

    while (bytes >= 1024 && unit < FileSizePipeUnits.PB) {
      bytes = bytes / 1024;
      unit++;
    }

    return bytes.toFixed(+ precision) + ' ' + FileSizePipeUnits[unit];
  }
}
